import { useLocation, useParams } from 'react-router-dom'
import ManageStock from './ManageStock'
import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

export const DetailInventoriesPacking = () => {
  const location = useLocation()
  const { id } = useParams()
  const dataState = location.state
  const { detail } = useSelector((s) => s.manageStock)
  const resolveStateLabel = (stateValue, fallback) => {
    if (typeof stateValue === 'string' || typeof stateValue === 'number') {
      return String(stateValue)
    }

    if (stateValue && typeof stateValue === 'object') {
      if (
        typeof stateValue.label === 'string' ||
        typeof stateValue.label === 'number'
      ) {
        return String(stateValue.label)
      }
      if (
        typeof stateValue.query === 'string' ||
        typeof stateValue.query === 'number'
      ) {
        return String(stateValue.query)
      }
    }

    return String(fallback)
  }

  const STORAGE_KEY = 'breadcrumbs'

  const [breadCrumbsData, setBreadCrumbsData] = useState(() => {
    const initialCrumb = {
      id,
      label: detail?.label ?? resolveStateLabel(dataState, id),
    }

    try {
      const saved = localStorage.getItem(STORAGE_KEY)
      if (saved) {
        const parsed = JSON.parse(saved)
        if (Array.isArray(parsed)) {
          const index = parsed.findIndex((crumb) => String(crumb.id) === String(id))
          if (index !== -1) {
            // If current ID is already in the breadcrumb, truncate to it
            return parsed.slice(0, index + 1)
          }
          // If not found, append current ID to the existing breadcrumb path
          return [...parsed, initialCrumb]
        }
      }
    } catch (error) {
      console.error('Error parsing breadcrumb data:', error)
    }
    return [initialCrumb]
  })

  useEffect(() => {
    try {
      const currentSaved = localStorage.getItem(STORAGE_KEY)
      const parsed = currentSaved ? JSON.parse(currentSaved) : null
      if (JSON.stringify(parsed) !== JSON.stringify(breadCrumbsData)) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(breadCrumbsData))
      }
    } catch (error) {
      console.error('Error saving breadcrumb data:', error)
    }
  }, [breadCrumbsData])

  useEffect(() => {
    if (detail?.label && String(detail?.id) === String(id)) {
      setBreadCrumbsData((prev) =>
        prev.map((crumb) =>
          String(crumb.id) === String(id)
            ? { ...crumb, label: detail.label }
            : crumb,
        ),
      )
    }
  }, [detail?.label, detail?.id, id])

  function onChangeBreadCrumb(data) {
    setBreadCrumbsData((prev) => {
      const index = prev.findIndex((crumb) => String(crumb.id) === String(data.id))
      const newCrumb = { id: data.id, label: data.label }

      if (index !== -1) {
        // If already in breadcrumbs, update label and truncate anything after it
        const updated = prev.slice(0, index)
        return [...updated, newCrumb]
      }

      // If not in breadcrumbs, append to the end
      return [...prev, newCrumb]
    })
  }

  return (
    <ManageStock
      isDetail={true}
      id={id}
      dataState={dataState}
      breadCrumbsData={breadCrumbsData}
      onManageBreadCrumb={onChangeBreadCrumb}
    />
  )
}
